import React, { useState, useEffect, Fragment } from "react";
import "./Mrf.css";
import Layout from "components/sales/layout/layout";
import localization from "../../../assets/localization/localization";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DatePicker from "components/sales/datePicker/datePicker";
import { FormGroup, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomModal from "../../valetServices/modal";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import Regex from "services/utils/regex/Regex";
import { toast } from "react-toastify";
import { DatePickerInput } from "rc-datepicker";
import * as moment from "moment";
import ModalPop from "components/sales/modal/modal";
import { useParams } from 'react-router-dom';

const CreateMrf = ({
  siteDetails,
  siteData,
  siteDataBySiteNo,
  imageUploadUrlPublic,
  siteByNo,
  getCategoryBrand,
  BrandData = [],
  getCategoryData,
  CategoryData = [],
  MaterialData = [],
  getmaterial,
  associateMaterial,
  associateMaterialDetails = [],
  locationPinCode,
  pincodeData,
  saveMaterial,
  savedMaterialRes = [],
  materialTypes,
  materialTypesRes = [],
  documentUploadUrlPublic,
  documentUrlDataPublic,
  getReportee,
  reportee = [],
  getWarehouse,
  warehouseRes = [],
  toEmployee = [],
  getToEmployee,
  getStoreAddress,
  storeAddress = [],
  erpInventory = [],
  getErpInventory,
  isView = false,
  isEdit = false,
  rowData = {},
  match,
}) => {
  const [count, setCount] = useState(0);
  const [maxDateState, setMaxDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [isFocus1, setIsFous1] = useState(true);
  const [inputList, setInputList] = useState([
    {
      site_no: "",
      material_id: "",
      client_name: "",
      date: "",
      remark: "",
      mrf_type_id: "",
      url: "",
      sloc: "",
      scope_id: "",
      payment_received: "",
      invoice_no: "",
      material_service_type: "",
      asm: "",
      am: "",
      remark_for_approver: "",
      mode_of_transport: "",
      invoice_amount: "",
      cheque_utr_no: "",
      cheque_utr_photo: "",
      cheque_utr_date: "",
      ti_generated: "",
      selected_invoice: "",
      to_emp_id: "",
      from_site_no: "",
      mrf_flow: "",
      po_number: "",
      advance_pick: "",
      address_id:'',
      is_billable: '',
      pi_no: ''
    },
  ]);
  const [payment, setPayment] = useState([
    {
      payment_mode: "",
      trans_amount: "",
      reference_number: "",
      adv_payment_date: "",
      status: "",
      bank: "",
      payment_remark: "",
      payment_document: ""
    },
  ]);

  const [invoiceNo, setInvoiceNo] = useState();
  const [invoiceAmt, setInvoiceAmt] = useState();
  const [associateMaterialData, setAssociateMaterialData] = useState([{}]);
  const [payData, setPayData] = useState();
  const [associateMaterialSelectedData, setAssociateMaterialSelectedData] =
    useState([]);
  const [billAddress, setBillAddress] = useState([
    {
      billing_contact_person: "",
      billing_contact_number: "",
      billing_contact_email: "",
      billing_city: "",
      billing_state: "",
      billing_pincode: "",
      billing_address_first: "",
      billing_address_second: "",
    },
  ]);
  const [shipAddress, setShipAddress] = useState([
    {
      delivery_contact_person: "",
      delivery_contact_number: "",
      delivery_contact_email: "",
      delivery_city: "",
      delivery_state: "",
      delivery_pincode: "",
      delivery_address_first: "",
      delivery_address_second: "",
    },
  ]);
  const [pincode, setPincode] = useState([]);
  const [isEmployee, setIsEmployee] = useState(false);
  const [employeeId, setEmployeeId] = useState(0);
  const [fastTagB2B, SetFastTagB2B] = useState(false);
  const [images, setImages] = useState([{ url: "" }]);
  const [poImages, setPoImage] = useState([{ url: "" }]);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [materialServiceType, setMaterialServiceType] = useState(0);
  const [nonCoatedServiceType, setNonCoatedServiceType] = useState([
    { name: "", description: "", qty: 1, value: 0 },
  ]);
  const [email, setEmail] = useState();
  const [contactNo, setcontactNo] = useState();
  const [materialTypeId, setMaterialTypeId] = useState(0);
  const [walletAmt, setWalletAmt] = useState(0.0);
  const [holdAmt, setHoldAmt] = useState(0.0);
  const [owedAmt, setOwedAmt] = useState(0.0);
  const [departmentId, setDepartmentId] = useState();
  const [storeId, setStoreId] = useState(0);
  const [fromId, setFromId] = useState("");
  const [submitDisable, setSubmitDisable] = useState(false);
  const [siteNo, setSiteNo] = useState(0);
  const [clientBillingAddress, setClientBillingAddress] = useState([])
  const [categoryId, setCategoryId] = useState(null);
  const [brandId, setBrandId] = useState(null);
  const [BrandNewData, setBrandNewData] = useState([]);
  const [isModal, setIsModal] = useState(false)
  const [clientShippingAddress, setClientShippingAddress] = useState([])
  const [routeRmId, setRmId] = useState("");
  const { id: rmId, siteId: rmSiteId } = useParams();
  const [billingAddressList, setBillingAddressList] = useState([]);
  const [shippingAddressList, setShippingAddressList] = useState([]);
  
  useEffect(() => {
    if (rmId) {
      setRmId(rmId);
    }
  }, [rmId]);

  const [isMaintenanceMrf, setIsMaintenanceMrf] = useState(false);
  const [rmSiteNo, rmSetSiteNo] = useState("");

  useEffect(() => {
    if (rmId && rmSiteId) {
      setIsMaintenanceMrf(true);
    } else {
      setIsMaintenanceMrf(false);
    }
  }, [rmId, rmSiteId]);

  
  useEffect(() => {
    (async () => {
      var maxDate = new Date();
      maxDate.setDate(maxDate.getDate() + 2);
      setMaxDate(maxDate);
      setIsLoading(true);
      if(!isMaintenanceMrf){
        await siteData();
      }
      if(!isMaintenanceMrf){
        await materialTypes();
      }
      await getWarehouse();
      if(!isMaintenanceMrf){
        await siteDataBySiteNo(0);
      }
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (storeId !== 0 && storeId !== "") {
        setIsLoading(true);
        await getStoreAddress(storeId);
        setIsLoading(false);
      }
    })();
  }, [storeId]);

  // useEffect(() => {
  //     (async () => {
  //         const deparment =
  //           (await JSON.parse(localStorage.getItem('profileDetails'))) &&
  //           JSON.parse(localStorage.getItem('profileDetails'))[0].department_id;
  //         setDepartmentId(deparment);
  //         if (deparment == 2) {
  //             handleInput("Yes", 'ti_generated');
  //         }
  //     })();
  // }, []);

  const handleMaterialType = async (typeId) => {
    if (typeId === "") {
      return false;
    }

    setAssociateMaterialData([{}]);
    setAssociateMaterialSelectedData([]);
    setIsEmployee(false);
    SetFastTagB2B(false);
    setMaterialTypeId(typeId);
    setEmployeeId(0);
    if (
      typeId === 5 ||
      typeId === 6 ||
      typeId === 13 ||
      typeId === 14 ||
      typeId === 15
    ) {
      setIsEmployee(true);

      // make employee mrf type to false when mrf is emp to site
      if (typeId === 14 || typeId === 15) {
        setIsEmployee(false);
      }

      let userDetails = JSON.parse(localStorage.getItem("loginDetails"));
      setEmployeeDetails(userDetails);
      setFromId(userDetails?.id);
      await getToEmployee();
      setEmployeeId(userDetails?.id);
      if (typeId === 6) {
        SetFastTagB2B(true);
        setIsLoading(true);
        await getReportee();
        setIsLoading(false);
      }
    }

    setIsLoading(true);
    await getmaterial(typeId);
    await getCategoryData(typeId);
    if(!isMaintenanceMrf){
      await siteDataBySiteNo((siteNo ?? 0), typeId);
      setClientBillingAddress([]);
      setClientShippingAddress([]);
    }
    setAssociateMaterialData([{}]);
    setIsLoading(false);
  };

  const handleConstInput = (e, index, name) => {
    // console.log(e);
    const list = [...payment];
    list[index][name] = e;
    setPayment(list);
  };

  const handleDateChange = (e, index, name) => {
    const current_datetime = moment(e).format("YYYY-MM-DD");
    const list = [...payment];
    list[index][name] = current_datetime;
    setPayment(list);
  };

  useEffect(() => {
    if (parseInt(siteByNo?.status) === 400) {
      setSubmitDisable(true);
      toast.warning(siteByNo?.message);
    } else {
      setSubmitDisable(false);
      if (siteByNo?.data?.siteShipAddress?.pincode !== undefined) {
        (async () => {
          await locationPinCode(siteByNo?.data?.siteShipAddress?.pincode);
        })();
      }
      if (
        siteByNo?.data?.credit_limit &&
        siteByNo?.data?.credit_limit?.credit_limit
      ) {
        setWalletAmt(parseFloat(siteByNo?.data?.credit_limit?.wallet_balance));
        setHoldAmt(parseFloat(siteByNo?.data?.credit_limit?.hold_amt));
        setOwedAmt(parseFloat(siteByNo?.data?.credit_limit?.owed_amt));
      }
    }
  }, [siteByNo]);

  //   {console.log(payment)}

  const handledropDownChange = (e, index, name) => {
    // console.log(e);

    const list = [...payment];
    if (!e) {
      list[index][name] = "";
    } else {
      const { value, id } = e;
      list[index][name] = id;
    }
    setPayment(list);
  };

  useEffect(() => {
    if (storeAddress?.data?.geo_pincode?.pincode !== undefined) {
      (async () => {
        await locationPinCode(storeAddress?.data?.geo_pincode?.pincode);
      })();
    }
  }, [storeAddress]);

  useEffect(() => {
    if (pincodeData && pincodeData.length > 0) {
      setPincode(pincodeData[0]);
    }
  }, [pincodeData]);

  const handleInput = (val, key) => {
    const list = [...inputList];
    if(key === 'address_id' && siteByNo?.data?.sites_address){
      setClientBillingAddress(siteByNo?.data?.sites_address[val])
    }
    if(key === 'ship_address_id' && siteByNo?.data?.sites_shipping_address){
      setClientShippingAddress(siteByNo?.data?.sites_shipping_address[val])
    }
    if(key === 'site_no' && siteByNo?.data?.sites_address){
      setBillingAddressList(siteByNo?.data?.sites_address);
      setClientBillingAddress([]);
    }
    if(key === 'site_no' && siteByNo?.data?.sites_shipping_address){
      setShippingAddressList(siteByNo?.data?.sites_shipping_address);
      setClientShippingAddress([]);
    }
    if(key === 'scope_id' && val === 2){
      list[0]['is_billable'] = '';
      list[0]['pi_no'] = ''; 
    }
    if(key === 'is_billable' && val === 'no'){
      list[0]['pi_no'] = ''; 
    }
    list[0][key] = val;
    setInputList([...list]);
  };

  const handleBillAddressInput = (val, key) => {
    const list = [...billAddress];
    list[0][key] = val;
    setBillAddress([...list]);
  };

  const handleShipAddressInput = (val, key) => {
    const list = [...shipAddress];
    list[0][key] = val;
    setShipAddress([...list]);
  };

  const handleSiteDetailsByNo = async (siteNo) => {
    if (siteNo === "") {
      return false;
    }
    setIsLoading(true);
    await siteDataBySiteNo(siteNo, materialTypeId);
    setIsLoading(false);
  };

  const handleMrfTypeChange = async (mrfType) => {
    if (!mrfType || isNaN(parseInt(mrfType))) {
      return;
    }
    setIsLoading(true);
    if (parseInt(mrfType) === 9) {
      await siteData(true, 9);
    }
    else if(parseInt(mrfType) === 1){
      await siteData(false, 1);
    } 
    else{
      await siteData();
    }
    setIsLoading(false);
  }

  const handleMaterialSelect = async (materialId) => {
    if (materialId === "") {
      return false;
    }

    setIsLoading(true);
    await associateMaterial(materialId, materialTypeId);
    setIsLoading(false);
    associateMaterialSelectedData.map((val) => {
      if (val !== "" && val === materialId) {
        const list = [...associateMaterialData];
        list.splice(list.length - 1, 1);
        setAssociateMaterialData([...list]);
        toast.error("This material already added");
        return false;
      }
    });
    /*if(parseInt(materialTypeId) === 14
            || parseInt(materialTypeId) === 17
            || parseInt(materialTypeId) === 18 || parseInt(materialTypeId) === 19 || parseInt(materialTypeId) === 20
            || parseInt(materialTypeId) === 21 || parseInt(materialTypeId) === 22){
            let res = await getErpInventory(materialTypeId, fromId, materialId, employeeDetails?.email !== undefined ? employeeDetails?.email : '')
            associateMaterialData.map((materialDetails, index) => {
                if (materialDetails.material !== undefined) {
                    if (materialDetails?.material?.id === materialId) {
                        materialDetails['material']['InventoryData'] = res
                    }
                }
            });
        }*/
    associateMaterialSelectedData.push(materialId);
    setAssociateMaterialSelectedData(associateMaterialSelectedData);
  };

  const handlePincode = async (pincode) => {
    await locationPinCode(pincode);
  };


  useEffect(() => {
    if (categoryId) {
      (async () => {
        setIsLoading(true);
        setBrandId(null);
        await getCategoryBrand(categoryId);
        // await getMateriaById(catId);
        
        setIsLoading(false);
      })();
    }
  }, [categoryId]);

  useEffect(() => {
    setBrandNewData(BrandData)
  },[BrandData])

  useEffect(() => {
    if (brandId && categoryId) {
      (async () => {
        setIsLoading(true);
        // console.log(brandId)
        await getmaterial(materialTypeId,brandId,categoryId);
        setIsLoading(false);
      })();
    }
  }, [brandId,categoryId]);

  useEffect(() => {
    if (
      associateMaterialDetails &&
      associateMaterialDetails !== [] &&
      associateMaterialDetails?.associate_material &&
      associateMaterialDetails?.associate_material !== [] &&
      associateMaterialDetails?.associate_material !== null
    ) {
      const keys = [
        "title",
        "material_name",
        "quantity",
        "price",
        "id",
        "class",
        "material_code",
      ];
      const data = associateMaterialDetails?.associate_material.map((element) =>
        Object.assign(
          {},
          keys.map((key) =>
            key === "title"
              ? { [key]: "Associated Material" }
              : key === "material_name"
              ? { ["name"]: element["material_name"] }
              : key === "quantity"
              ? { ["Quantity"]: element["associate_qty"] }
              : key === "price"
              ? {
                  ["sale_value"]:
                    element["sale_value"] === null ? 0 : element["sale_value"],
                }
              : key === "id"
              ? { ["id"]: element["id"] === null ? 0 : element["id"] }
              : key === "class"
              ? { ["class"]: element["material_class"] }
              : key === "material_code"
              ? { ["material_code"]: element["material_code"] }
              : ""
          )
        )
      );

      if (associateMaterialData && associateMaterialData.length > 0) {
        associateMaterialData[associateMaterialData.length] = {
          associated_material: data,
          material: {
            title: "Title",
            name: associateMaterialDetails?.material_name,
            brand_name: associateMaterialDetails?.brand_name,
            sale_value:
              associateMaterialDetails?.sale_value !== null
                ? associateMaterialDetails?.sale_value
                : 0,
            Quantity: 1,
            id: associateMaterialDetails?.id,
            code: associateMaterialDetails?.material_code,
            is_refundable: false,
            Inventory: "",
            InventoryData: [],
          },
        };
      }
      setAssociateMaterialData(associateMaterialData);
    }
  }, [associateMaterialDetails]);

  const handleConfirmation = async () => {
    setIsModal(true)
  }
  const handleModalClose = async () => {
    setIsModal(false)
  }

  const handleOnSubmitForm = async () => {
    setIsModal(false)
    const siteList = [...inputList];
    const billList = [...billAddress];
    const shipList = [...shipAddress];
    let requestParams = {
      // shpping addrress for all material type is required
      delivery_contact_number:
        shipList[0]["delivery_contact_number"] === ""
          ? siteByNo?.data?.poc?.contact_no
          : shipList[0]["delivery_contact_number"],
      delivery_contact_email:
        shipList[0]["delivery_contact_email"] === ""
          ? siteByNo?.data?.poc?.email
          : shipList[0]["delivery_contact_email"],
      delivery_city:
        pincode?.city_name === undefined
          ? siteByNo?.data?.siteShipAddress?.city
          : pincode?.city_name,
      delivery_state:
        pincode?.state_name === undefined
          ? siteByNo?.data?.siteShipAddress?.state
          : pincode?.state_name,
      delivery_contact_person:
        shipList[0]["delivery_contact_person"] === ""
          ? siteByNo?.data?.poc?.name
          : shipList[0]["delivery_contact_person"],
      delivery_pincode:
        shipList[0]["delivery_pincode"] === ""
          ? siteByNo?.data?.siteShipAddress?.pincode
          : shipList[0]["delivery_pincode"],
      delivery_address_first:
        shipList[0]["delivery_address_first"] === ""
          ? siteByNo?.data?.siteShipAddress?.address_line_1
          : shipList[0]["delivery_address_first"],
      delivery_address_second:
        shipList[0]["delivery_address_second"] === ""
          ? siteByNo?.data?.siteShipAddress?.address_line_2
          : shipList[0]["delivery_address_second"],
      delivery_address_id:
        siteByNo?.data?.siteShipAddress?.id !== undefined
          ? siteByNo?.data?.siteShipAddress?.id
          : 0,
      item_id: [],
      item_quantity: [],
      item_unit: [],
      item_code_id: [],
      is_refundable: [],
      specification:[],
      inventory: [],
    };
    requestParams["mrf_type_id"] = siteList[0]["mrf_type_id"];
    requestParams["mrf_flow"] = siteList[0]["mrf_flow"];
    requestParams["po_number"] = siteList[0]["po_number"];
    requestParams["advance_pick"] = siteList[0]["advance_pick"];


    //will work for emp to site mrf
    if (parseInt(requestParams["mrf_type_id"]) === 14) {
      setIsEmployee(false);
      requestParams["employee_id"] = employeeId;
    }

    // if (requestParams['mrf_type_id'] !== 5 && requestParams['mrf_type_id'] !== 13 && requestParams['mrf_type_id'] !== 15 && requestParams['mrf_type_id'] !== 16) {

    if (
      siteList[0]["mrf_type_id"] !== 5 &&
      siteList[0]["mrf_type_id"] !== 13 &&
      siteList[0]["mrf_type_id"] !== 15 &&
      siteList[0]["mrf_type_id"] !== 16
    ) {
      requestParams["site_no"] =
        siteList[0]["site_no"] === ""
          ? siteByNo?.data?.siteDetails?.site_no
          : siteList[0]["site_no"];
      requestParams["client_name"] =
        siteList[0]["client_name"] === ""
          ? siteByNo?.data?.lead?.client_name
          : siteList[0]["client_name"];
      requestParams["billing_contact_number"] =
        billList[0]["billing_contact_number"] === ""
          ? siteByNo?.data?.poc?.contact_no
          : billList[0]["billing_contact_number"];
      requestParams["billing_contact_email"] =
        billList[0]["billing_contact_email"] === ""
          ? siteByNo?.data?.poc?.email
          : billList[0]["billing_contact_email"];

      requestParams["billing_city"] = clientBillingAddress?.city !== undefined  ? clientBillingAddress?.city :
        billList[0]["billing_city"] === ""
          ? siteByNo?.data?.siteBillAddress?.city
          : billList[0]["billing_city"];
          
      requestParams["billing_state"] = clientBillingAddress?.state !== undefined  ? clientBillingAddress?.state :
        billList[0]["billing_state"] === ""
          ? siteByNo?.data?.siteBillAddress?.state
          : billList[0]["billing_state"];

      requestParams["billing_contact_person"] = (clientBillingAddress?.registered_name !== undefined && clientBillingAddress?.registered_name !== null && clientBillingAddress?.registered_name !== "")  ? clientBillingAddress?.registered_name : billList[0]["billing_contact_person"] === "" ? siteByNo?.data?.poc?.name : billList[0]["billing_contact_person"];

      requestParams["billing_pincode"] = clientBillingAddress?.pincode !== undefined  ? clientBillingAddress?.pincode : billList[0]["billing_pincode"] === ""
          ? siteByNo?.data?.siteBillAddress?.pincode
          : billList[0]["billing_pincode"];

      requestParams["billing_address_first"] = clientBillingAddress?.address_line_1 !== undefined  ? clientBillingAddress?.address_line_1 : billList[0]["billing_address_first"] === ""
          ? siteByNo?.data?.siteBillAddress?.address_line_1
          : billList[0]["billing_address_first"];

      requestParams["billing_address_second"] = clientBillingAddress?.address_line_2 !== undefined  ? clientBillingAddress?.address_line_2 : billList[0]["billing_address_second"] === ""
          ? siteByNo?.data?.siteBillAddress?.address_line_2
          : billList[0]["billing_address_second"];

      requestParams["billing_address_id"] =
          clientBillingAddress?.id !== undefined ? clientBillingAddress.id : siteByNo?.data?.siteBillAddress?.id !== undefined
          ? siteByNo?.data?.siteBillAddress?.id
          : 0;

      requestParams["site_id"] = siteByNo?.data?.siteDetails?.id;
      requestParams["test123"] = 0;
    } else {
      // this will work for employee and B2B material types
      requestParams["delivery_address_second"] =
        shipList[0]["delivery_address_second"] !== ""
          ? shipList[0]["delivery_address_second"]
          : "";
      requestParams["billing_contact_number"] =
        shipList[0]["delivery_contact_number"];
      requestParams["billing_contact_email"] =
        shipList[0]["delivery_contact_email"];
      requestParams["billing_city"] = pincode?.city_name;
      requestParams["billing_state"] = pincode?.city_name;
      requestParams["billing_contact_person"] =
        shipList[0]["delivery_contact_person"];
      requestParams["billing_pincode"] = shipList[0]["delivery_pincode"];
      requestParams["billing_address_first"] =
        shipList[0]["delivery_address_first"];
      requestParams["billing_address_second"] =
        shipList[0]["delivery_address_second"] ?? "";
      requestParams["billing_address_id"] = 0;
      requestParams["am"] = siteList[0]["am"];
      requestParams["asm"] = siteList[0]["asm"];
      requestParams["employee_id"] = employeeId;
    }

    if (
      requestParams["mrf_type_id"] === 16 ||
      requestParams["mrf_type_id"] === 15
    ) {
      requestParams["delivery_contact_number"] =
        storeAddress?.data?.phone_number;
      requestParams["delivery_contact_email"] = storeAddress?.data?.email;
      requestParams["delivery_city"] = storeAddress?.data?.geo_city?.city_name;
      requestParams["delivery_state"] =
        storeAddress?.data?.geo_state?.state_name;
      requestParams["delivery_contact_person"] =
        storeAddress?.data?.company_name;
      requestParams["delivery_pincode"] =
        storeAddress?.data?.geo_pincode?.pincode;
      requestParams["delivery_address_first"] =
        storeAddress?.data?.address_first;
      requestParams["delivery_address_second"] =
        storeAddress?.data?.address_second;
      requestParams["delivery_address_id"] = 0;

      requestParams["billing_contact_number"] =
        storeAddress?.data?.phone_number;
      requestParams["billing_contact_email"] = storeAddress?.data?.email;
      requestParams["billing_city"] = storeAddress?.data?.geo_city?.city_name;
      requestParams["billing_state"] =
        storeAddress?.data?.geo_state?.state_name;
      requestParams["billing_contact_person"] =
        storeAddress?.data?.company_name;
      requestParams["billing_pincode"] =
        storeAddress?.data?.geo_pincode?.pincode;
      requestParams["billing_address_first"] =
        storeAddress?.data?.address_first;
      requestParams["billing_address_second"] =
        storeAddress?.data?.address_second;
      requestParams["billing_address_id"] = 0;
    }

    if (requestParams["mrf_type_id"] === 9) {
      requestParams["delivery_city"] = clientShippingAddress?.city !== undefined
        ? clientShippingAddress?.city
        : pincode?.city_name === undefined
          ? siteByNo?.data?.siteShipAddress?.city
          : pincode?.city_name;

      requestParams["delivery_state"] = clientShippingAddress?.state !== undefined
        ? clientShippingAddress?.state
        : pincode?.state_name === undefined
          ? siteByNo?.data?.siteShipAddress?.state
          : pincode?.state_name;

      requestParams["delivery_contact_person"] = (clientShippingAddress?.registered_name !== undefined && clientShippingAddress?.registered_name !== '')
        ? clientShippingAddress?.registered_name
        : shipList[0]["delivery_contact_person"] === ""
          ? siteByNo?.data?.poc?.name
          : shipList[0]["delivery_contact_person"];

      requestParams["delivery_pincode"] = clientShippingAddress?.pincode !== undefined
        ? clientShippingAddress?.pincode
        : shipList[0]["delivery_pincode"] === ""
          ? siteByNo?.data?.siteShipAddress?.pincode
          : shipList[0]["delivery_pincode"];

      requestParams["delivery_address_first"] = clientShippingAddress?.address_line_1 !== undefined
        ? clientShippingAddress?.address_line_1
        : shipList[0]["delivery_address_first"] === ""
          ? siteByNo?.data?.siteShipAddress?.address_line_1
          : shipList[0]["delivery_address_first"];

      requestParams["delivery_address_second"] = clientShippingAddress?.address_line_2 !== undefined
        ? clientShippingAddress?.address_line_2
        : shipList[0]["delivery_address_second"] === ""
          ? siteByNo?.data?.siteShipAddress?.address_line_2
          : shipList[0]["delivery_address_second"];

      requestParams["delivery_address_id"] = clientShippingAddress?.id !== undefined
        ? clientShippingAddress?.id
        : siteByNo?.data?.siteShipAddress?.id !== undefined
          ? siteByNo?.data?.siteShipAddress?.id
          : 0;
    }

    requestParams["planned_delivery_date"] = siteList[0]["date"];
    requestParams["sloc"] = siteList[0]["sloc"];
    requestParams["payment_received"] = siteList[0]["payment_received"];
    requestParams["invoice_no"] = siteList[0]["invoice_no"];
    requestParams["scope"] = siteList[0]["scope_id"] === 1 ? "Park+" : "Client";
    requestParams["scope_id"] = siteList[0]["scope_id"];
    requestParams["invoice_amount"] = siteList[0]["invoice_amount"];
    requestParams["mode_of_transport"] = siteList[0]["mode_of_transport"];
    requestParams["images_url"] = images;
    requestParams["po_images_url"] = poImages;
    requestParams["comment"] = siteList[0]["remark"];
    requestParams["remark_for_approver"] = siteList[0]["remark_for_approver"];
    requestParams["cheque_utr_no"] = siteList[0]["cheque_utr_no"];
    requestParams["cheque_utr_date"] = siteList[0]["cheque_utr_date"];
    requestParams["cheque_utr_photo"] = siteList[0]["cheque_utr_photo"];
    requestParams["ti_generated"] =
      siteList[0]["ti_generated"] !== "" ? siteList[0]["ti_generated"] : "No";
    requestParams["to_emp_id"] = siteList[0]["to_emp_id"];
    requestParams["from_site_no"] = siteList[0]["from_site_no"];
    requestParams['is_billable'] = siteList[0]['is_billable'];
    requestParams['pi_no'] = siteList[0]['pi_no'];

    if (requestParams["mode_of_transport"] === "") {
      toast.error("Mode of transport is required");
      return false;
    }

    if (requestParams["comment"] === "") {
      toast.error("Remark for store is required");
      return false;
    }

    if (requestParams["remark_for_approver"] === "") {
      toast.error("Remark for approver is required");
      return false;
    }

    if (requestParams["images_url"][0]["url"] === "") {
      toast.error("Atleast one attachment is required");
      return false;
    }

    if (requestParams["scope_id"] === 2) {
      if (requestParams["ti_generated"] == "Yes") {
        if (requestParams["invoice_no"] === "") {
          toast.error("Invoice no is required");
          return false;
        } else if (requestParams["payment_received"] === "") {
          toast.error("Payment received is required");
          return false;
        } else if (requestParams["invoice_amount"] === "") {
          toast.error("Invoice amount is required");
          return false;
        }
        // else if (requestParams["images_url"][0]["url"] === "") {
        //   toast.error("Atleast one attachment is required");
        //   return false;
        // }
      } else if (requestParams["ti_generated"] == "No") {
        requestParams["payment_received"] = "No";
      } else if (requestParams["ti_generated"] === "") {
        toast.error("TI generated is required!");
        return false;
      }
    } else if (requestParams["scope_id"] === 1) {
      if (requestParams["payment_received"] === "") {
        requestParams["payment_received"] = "Yes";
      }
      if (requestParams["is_billable"] === "") {
        toast.error("Will client pay for this MRF - Yes / No");
        return false;
      }else if(requestParams['is_billable'] == 'yes' && requestParams["pi_no"] === ""){
        toast.error("Performa Invoice is required if client pay for this MRF");
        return false;
      }
    }

    // will work for emp to site mrf type
    if (
      requestParams["mrf_type_id"] === 14 &&
      requestParams["site_id"] === ""
    ) {
      // requestParams['site_no'] = null
      // requestParams['to_site_id'] = requestParams['site_id']
      toast.error("Please select site");
    }

    // //will work for only site to site mrf type
    // if(requestParams['mrf_type_id'] === 17 || requestParams['mrf_type_id'] === 18 || requestParams['mrf_type_id'] === 19
    // || requestParams['mrf_type_id'] === 20 || requestParams['mrf_type_id'] === 21 || requestParams['mrf_type_id'] === 22){
    //     requestParams['to_site_id'] = requestParams['site_id']
    // }

    if (
      (requestParams["mrf_type_id"] === 3 ||
        requestParams["mrf_type_id"] === 6) &&
      siteList[0]["material_service_type"] === 2
    ) {
      toast.error("Tag can't have non coated material");
      return false;
    }
    requestParams["material_service_type"] =
      siteList[0]["material_service_type"] === 1 ? "Mat Code" : "Non Mat Code";
    requestParams["material_service_type_id"] =
      siteList[0]["material_service_type"];

    if (materialServiceType === 1) {
      // for coated service material type
      associateMaterialData.map((val, index) => {
        if (index > 0) {
          if (val?.material?.id !== undefined) {
            requestParams.item_id.push(val?.material?.id);
            requestParams.item_quantity.push(val?.material?.Quantity);
            requestParams.item_unit.push(val?.material?.sale_value);
            requestParams.item_code_id.push(val?.material?.code);
            requestParams.is_refundable.push(val?.material?.is_refundable);
            requestParams.specification.push(val?.material?.specification);
            requestParams.inventory.push(val?.material?.Inventory);
          }
          if (val?.associated_material !== undefined) {
            val?.associated_material.map((ass_ma) => {
              requestParams.item_id.push(ass_ma[4]?.id);
              requestParams.item_quantity.push(
                ass_ma[2]?.Quantity * val?.material?.Quantity
              );
              requestParams.item_unit.push(ass_ma[3]?.sale_value);
              requestParams.item_code_id.push(ass_ma[6]?.material_code);
            });
          }
        }
      });
    } else if (materialServiceType === 2) {
      // for non coated service type
      let isBroken = false;
      nonCoatedServiceType.map((val) => {
        if (val?.name === "") {
          toast.error("Material Name is required");
          isBroken = true;
        } else if (val?.description === "") {
          toast.error("Description is required for " + val?.name);
          isBroken = true;
        } else if (val?.qty <= 0) {
          // check quantity for non mat material is greater than 0 or not
          toast.error("Quantity for " + val?.name + " Can't be " + val?.qty);
          isBroken = true;
        } else if (val?.value === "") {
          toast.error("Price is required for " + val?.name);
          isBroken = true;
        }
      });

      // if quantity is less than 1 return request from here
      if (isBroken) {
        return false;
      }
      requestParams["material_services"] = nonCoatedServiceType;
    } else {
      toast.error("Please select material");
    }

    requestParams["advance_payment"] = payment;
    // console.log("requestParamsrequestParamsrequestParams "+JSON.stringify(requestParams))
    // return false
    setIsLoading(true);
    // console.log(requestParams);
    requestParams["rm_ticket_id"] = routeRmId;
    await saveMaterial(requestParams);
    setIsLoading(false);
    setCount(count + 1);
  };

  const handleTrash = (id) => {
    // this is for delete added material for coated
    associateMaterialData.map((materialDetails, index) => {
      if (id !== "") {
        if (materialDetails?.material?.id === id) {
          associateMaterialData.splice(index, 1);
          associateMaterialSelectedData.map((val, i) => {
            if (val === id) {
              associateMaterialSelectedData.splice(i, 1);
              setAssociateMaterialSelectedData(associateMaterialSelectedData);
            }
          });
        }
      }
    });
  };

  const handleMaterialPrice = (type, field, val, id) => {
    // console.log(type,field,val,id)
    // if(type === 'associated'){
    //     associateMaterialData.map((materialDetails, index) => {
    //         if(materialDetails?.associated_material !== undefined){
    //             materialDetails?.associated_material.map((ass_mat, i) => {
    //                 if(ass_mat[4]?.id === id){
    //                     if(field === 'Quantity'){
    //                         materialDetails['associated_material'][i][2]['Quantity'] = val
    //                     }else{
    //                         materialDetails['associated_material'][i][3]['sale_value'] = val
    //                     }
    //                 }
    //             })
    //         }
    //     })
    // }else
    // console.log(field+" "+typeof val)
    // console.log("inventory "+JSON.stringify(val))
    if (type === "material") {
      // check sales value and quantity dynamically
      associateMaterialData.map((materialDetails, index) => {
        if (materialDetails.material !== undefined) {
          // console.log(val);
          if (materialDetails?.material?.id === id) {
            if (field === "Quantity") {
              materialDetails["material"]["Quantity"] = val;
            } else if (field === "sale_value") {
              materialDetails["material"]["sale_value"] = val;
            } else if (field === "Inventory") {
              materialDetails["material"]["Inventory"] = [];
              if (val[0] !== undefined) {
                materialDetails["material"]["Inventory"] = "";
                val.map((v, i) => {
                  if (i === 0) {
                    materialDetails["material"]["Inventory"] = v?.name;
                  } else {
                    materialDetails["material"]["Inventory"] += "," + v?.name;
                  }
                });
              }
            } else if (field === "refundable") {
              materialDetails["material"]["is_refundable"] = val;
            }else if (field === "specification") {
              materialDetails["material"]["specification"] = val;
            }
          }
        }
      });
    }

    setTimeout(() => {
      setIsLoading(true);
      setIsLoading(false);
    }, 1000);
  };

  const saveImages = (index, value) => {
    let list = [...images];
    list[index]["url"] = value;
    setImages([...list]);
  };

  const savePoImage = (value) => {
    let list = [...poImages];
    list[0]["url"] = value;
    setPoImage([...list]);
  };

  const handleAddImages = () => {
    setImages([
      ...images,
      {
        url: "",
      },
    ]);
  };

  const handleRemove = (index) => {
    const list = [...images];
    list.splice(index, 1);
    setImages(list);
  };

  const handleCoatedServiceAdd = () => {
    setNonCoatedServiceType([
      ...nonCoatedServiceType,
      {
        name: "",
        description: "",
        qty: 1,
        value: 0,
      },
    ]);
  };

  const handleCoatedServiceRemove = (index) => {
    const list = [...nonCoatedServiceType];
    list.splice(index, 1);
    setNonCoatedServiceType(list);
  };

  const saveCoatedService = (index, value, key) => {
    let list = [...nonCoatedServiceType];
    list[index][key] = value;
    setNonCoatedServiceType([...list]);
  };

  const findById = (e, id) => {
    for (let o of e) {
      if (o.id == id) {
        return o.amount;
      }
    }
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <label className={`label label info-label`}>
          Wallet Amt: {walletAmt}
        </label>
        <label className={`label label info-label`}>Hold Amt: {holdAmt}</label>
        <label className={`label label info-label`}>Owed Amt: {owedAmt}</label>
      </Fragment>
    );
  };

  useEffect(() => {
    if (materialServiceType === 2) {
      setAssociateMaterialData([{}]);
      setTimeout(() => {
        setIsLoading(true);
        setIsLoading(false);
      }, 1000);
    }
  }, [materialServiceType]);

  // {console.log(clientBillingAddress)}

useEffect(() => {
  if (isMaintenanceMrf && materialTypesRes?.length > 0) {
    const maintenanceType = materialTypesRes.find(
      (item) => item.name === "Maintenance MRF"
    );
    if (maintenanceType) {
      handleMaterialType(maintenanceType.id);
      handleInput(maintenanceType.id, "mrf_type_id");
      handleMrfTypeChange(maintenanceType.id);
    }
  }
}, [isMaintenanceMrf, materialTypesRes]);

useEffect(() => {
  if (siteDetails?.length > 0 && isMaintenanceMrf) {
    const matchedSite = siteDetails.find(
      (site) => site.site_id === parseInt(rmSiteId)
    );
    if (matchedSite) {
      rmSetSiteNo(matchedSite.name);
      handleSiteDetailsByNo(matchedSite.id, materialTypeId);
      handleInput(matchedSite.id, "site_no");
      setSiteNo(matchedSite.id);
    }
  }
}, [siteDetails, rmSiteId, materialTypeId]);

useEffect(() => {
  if(siteDetails?.length > 0){
    setBillingAddressList(siteDetails[0]?.sites_address ?? []);
    setShippingAddressList(siteDetails[0]?.sites_shipping_address ?? []);
  }
}, [siteDetails]);

  return (
    <>
      <Layout
        title={localization.materialRequistionForm}
        isLoading={isLoading}
        isGoback={true}
        Buttons={headerBtns}
      >
        <div className="container-fluid">
          <div className="card">
            {savedMaterialRes !== null &&
              savedMaterialRes?.response?.status !== 200 && (
                <CustomModal
                  msg={savedMaterialRes?.response?.message}
                  click={count}
                />
              )}
            {savedMaterialRes !== null &&
              savedMaterialRes?.response?.status === 200 && (
                <CustomModal
                  msg={savedMaterialRes?.response?.message}
                  isPageLoad={true}
                  click={count}
                />
              )}
            <div className="card-header">{localization.siteDetails}</div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-4">
                  <DropDownInput
                    label={localization.materialTypes}
                    data={materialTypesRes}
                    getIdValue={(val) => {
                      handleMaterialType(val.id);
                      handleInput(val.id, "mrf_type_id");
                      handleMrfTypeChange(val.id)
                    }}
                    value={isMaintenanceMrf ? 'Maintenance MRF' : ""}
                    isStarRequired={true}
                    disabled={isMaintenanceMrf}
                  />
                </div>
                {(employeeId !== 0 ||
                  parseInt(materialTypeId) === 13 ||
                  parseInt(materialTypeId) === 14 ||
                  parseInt(materialTypeId) === 15) && (
                  <>
                    <div className="col-sm-4">
                      <ConstantInput
                        label={localization.name}
                        value={employeeDetails?.name}
                        type="text"
                        handleChange={(val) => () => {}}
                        disabled={true}
                      />
                    </div>
                    <div className="col-sm-4">
                      <ConstantInput
                        label={localization.email}
                        value={employeeDetails?.email}
                        type="text"
                        handleChange={(val) => () => {}}
                        disabled={true}
                      />
                    </div>
                    {parseInt(materialTypeId) === 13 && (
                      <div className="col-sm-4">
                        <DropDownInput
                          label={((parseInt(materialTypeId) === 13) || (parseInt(materialTypeId) === 15)) ? 'From' : localization.to}
                          data={toEmployee}
                          getIdValue={(val) => handleInput(val.id, "to_emp_id")}
                          value={""}
                        />
                      </div>
                    )}
                  </>
                )}
                {(parseInt(materialTypeId) === 16 ||
                  parseInt(materialTypeId) === 18 ||
                  parseInt(materialTypeId) === 17 ||
                  parseInt(materialTypeId) === 19 ||
                  parseInt(materialTypeId) === 20 ||
                  parseInt(materialTypeId) === 21 ||
                  parseInt(materialTypeId) === 22) && (
                  <div className="col-sm-4">
                    <DropDownInput
                      label={localization.fromSite}
                      data={siteDetails}
                      getIdValue={(val) => {
                        handleInput(val.id, "from_site_no");
                        setFromId(val.id);
                      }}
                      value={""}
                      isStarRequired={true}
                    />
                  </div>
                )}
                {/*when mrf type is not employee and store*/}
                {parseInt(materialTypeId) !== 5 &&
                  parseInt(materialTypeId) !== 15 &&
                  parseInt(materialTypeId) !== 16 &&
                  parseInt(materialTypeId) !== 13 && (
                    <>
                      <div className="col-sm-4">
                        <DropDownInput
                          label={localization.SiteNo}
                          data={siteDetails}
                          getIdValue={(val) => {
                            handleSiteDetailsByNo(val.id, materialTypeId);
                            handleInput(val.id, "site_no");
                            setSiteNo(val.id!==undefined || val.id!='' || val.id !== null ? val.id : 0);
                          }}
                          value={isMaintenanceMrf ? rmSiteNo : ""}
                          isStarRequired={true}
                          disabled={parseInt(materialTypeId) === 0 || isMaintenanceMrf}
                        />    
                      </div>
                      <div className="col-sm-4">
                        <ConstantInput
                          label={localization.clientName}
                          value={siteByNo?.data?.lead?.client_name}
                          type="text"
                          handleChange={(val) => () => {}}
                          disabled={true}
                        />
                      </div>
                      <div className="col-sm-4">
                        <ConstantInput
                          label={localization.businessType}
                          value={siteByNo?.data?.lead_type?.name}
                          type="text"
                          handleChange={(val) => () => {}}
                          disabled={true}
                        />
                      </div>
                      <div className="col-sm-4">
                        <ConstantInput
                          label={localization.commercialType}
                          value={
                            siteByNo?.data?.lead_commercial
                              ?.lead_commercial_type?.name
                          }
                          type="text"
                          handleChange={(val) => () => {}}
                          disabled={true}
                        />
                      </div>
                    </>
                  )}
                {(parseInt(materialTypeId) === 15 ||
                  parseInt(materialTypeId) === 16) && (
                  <div className="col-sm-4">
                    <DropDownInput
                      label={localization.slocWarehouse}
                      data={warehouseRes}
                      getIdValue={(val) => {
                        handleInput(val.id, "sloc");
                        setStoreId(val.id);
                      }}
                      value={""}
                    />
                  </div>
                )}
                {fastTagB2B && (
                  <>
                    <div className="col-sm-4">
                      <DropDownInput
                        label={localization.ASM}
                        data={reportee?.ASM}
                        getIdValue={(val) => handleInput(val.id, "asm")}
                        value={""}
                        isStarRequired={true}
                      />
                    </div>
                    <div className="col-sm-4">
                      <DropDownInput
                        label={localization.AM}
                        data={reportee?.AM}
                        getIdValue={(val) => handleInput(val.id, "am")}
                        value={""}
                        isStarRequired={true}
                      />
                    </div>
                  </>
                )}


                <div className="col-sm-4">
                  <ConstantInput
                      label={localization.gstNumber}
                      value={
                        clientBillingAddress?.client_gst !== undefined  ? clientBillingAddress?.client_gst :
                        siteByNo?.data?.lead_commercial?.gst_no ?  siteByNo?.data?.lead_commercial?.gst_no : ''
                      }
                      type="text"
                      disabled={true}
                  />
                </div>
                <div className="col-sm-4">
                  <ConstantInput
                      label={localization.registeredName}
                      value={
                        siteByNo?.data?.client_name
                      }
                      type="text"
                      disabled={true}
                  />
                </div>
                {isMaintenanceMrf && (
                  <div className="col-sm-4">
                    <ConstantInput
                      label="RM Ticket ID"
                      value={rmId || ""}
                      disabled={true}
                    />
                  </div>
                )}
                {console.log('clientBillingAddress', clientBillingAddress)}
                {console.log('clientShippingAddress', clientShippingAddress)}
                {(parseInt(materialTypeId) !== 5 && parseInt(materialTypeId) !== 13 && parseInt(materialTypeId) !== 15
                && parseInt(materialTypeId) !== 16) && siteNo !== 0 &&
                    <div className="col-sm-4">
                      <DropDownInput
                          label={localization.addBillingAddress}
                          data={siteByNo?.data?.site_address}
                          getIdValue={(val) => handleInput(val.id, "address_id")}
                          // value={clientBillingAddress?.id ?? ""}
                          value={""}
                          isStarRequired={true}
                          required={true}
                      />
                    </div>
                }
                {(parseInt(materialTypeId) === 9) && siteNo !== 0 &&
                    <div className="col-sm-4">
                      <DropDownInput
                          label={localization.addShippingAddress}
                          data={siteByNo?.data?.site_shipping_address}
                          getIdValue={(val) => handleInput(val.id, "ship_address_id")}
                          // value={clientShippingAddress?.id ?? ""}
                          value={""}
                          isStarRequired={true}
                          required={true}
                      />
                    </div>
                }
              </div>
            </div>
          </div>

          {parseInt(materialTypeId) !== 5 &&
            parseInt(materialTypeId) !== 13 && (
              <>
                <div className="card">
                  <div className="card-header">{localization.billedTo}</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <ConstantInput
                          label={localization.contactName}
                          value={
                            (clientBillingAddress?.registered_name !== undefined && clientBillingAddress?.registered_name !== null && clientBillingAddress?.registered_name !== "") ? clientBillingAddress?.registered_name :
                            siteByNo?.data?.poc?.name !== undefined
                              ? siteByNo?.data?.poc?.name
                              : storeAddress?.data?.company_name
                          }
                          type="text"
                          handleChange={(val) =>
                            handleBillAddressInput(
                              val,
                              "billing_contact_person"
                            )
                          }
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <ConstantInput
                          label={localization.phoneNumber}
                          value={
                            siteByNo?.data?.poc?.contact_no !== undefined
                              ? siteByNo?.data?.poc?.contact_no
                              : storeAddress?.data?.phone_number
                          }
                          type="number"
                          handleChange={(val) =>
                            handleBillAddressInput(
                              val,
                              "billing_contact_number"
                            )
                          }
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <ConstantInput
                          label={localization.email}
                          value={
                            siteByNo?.data?.poc?.email !== undefined
                              ? siteByNo?.data?.poc?.email
                              : storeAddress?.data?.email
                          }
                          type="text"
                          handleChange={(val) =>
                            handleBillAddressInput(val, "billing_contact_email")
                          }
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <ConstantInput
                          label={localization.pinCode}
                          value={
                            clientBillingAddress?.pincode !== undefined  ? clientBillingAddress?.pincode : siteByNo?.data?.siteBillAddress?.pincode !==
                            undefined
                                ? storeAddress?.data?.geo_pincode?.pincode : ''
                          }
                          type="text"
                          handleChange={(val) =>
                            handleBillAddressInput(val, "billing_pincode")
                          }
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <ConstantInput
                          label={localization.city}
                          value={
                            clientBillingAddress?.city !== undefined ? clientBillingAddress?.city : siteByNo?.data?.siteBillAddress?.city !== undefined
                              // ? siteByNo?.data?.siteBillAddress?.city
                              ? storeAddress?.data?.geo_city?.city_name : ''
                          }
                          type="text"
                          handleChange={(val) =>
                            handleBillAddressInput(val, "billing_city")
                          }
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <ConstantInput
                          label={localization.state}
                          value={
                            clientBillingAddress?.state !== undefined ? clientBillingAddress?.state : siteByNo?.data?.siteBillAddress?.state !== undefined
                              // ? siteByNo?.data?.siteBillAddress?.state
                              ? storeAddress?.data?.geo_state?.state_name :''
                          }
                          type="text"
                          handleChange={(val) =>
                            handleBillAddressInput(val, "billing_state")
                          }
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <ConstantInput
                          label={localization.address1}
                          value={
                            clientBillingAddress?.address_line_1 !== undefined ? clientBillingAddress?.address_line_1 : siteByNo?.data?.siteBillAddress?.address_line_1 !==
                            undefined
                              // ? siteByNo?.data?.siteBillAddress?.address_line_1
                              ? storeAddress?.data?.address_first : ''
                          }
                          type="text"
                          handleChange={(val) =>
                            handleBillAddressInput(val, "billing_address_first")
                          }
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <ConstantInput
                          label={localization.address2}
                          value={
                            clientBillingAddress?.address_line_2 !== undefined ? clientBillingAddress?.address_line_2 : siteByNo?.data?.siteBillAddress?.address_line_2 !==
                            undefined
                              // ? siteByNo?.data?.siteBillAddress?.address_line_2
                              ? storeAddress?.data?.address_second : ''
                          }
                          type="text"
                          handleChange={(val) =>
                            handleBillAddressInput(
                              val,
                              "billing_address_second"
                            )
                          }
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          <div className="card">
            <div className="card-header">{localization.shippedTo}</div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <ConstantInput
                    label={localization.contactName}
                    value={
                      (clientShippingAddress?.registered_name !== undefined && clientShippingAddress?.registered_name !== null && clientShippingAddress?.registered_name !== "") ? clientShippingAddress?.registered_name :
                      siteByNo?.data?.poc?.name !== undefined
                        ? siteByNo?.data?.poc?.name
                        : storeAddress?.data?.company_name
                    }
                    type="text"
                    handleChange={(val) =>
                      handleShipAddressInput(val, "delivery_contact_person")
                    }
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <ConstantInput
                    label={localization.phoneNumber}
                    value={
                      siteByNo?.data?.poc?.contact_no !== undefined
                        ? siteByNo?.data?.poc?.contact_no
                        : storeAddress?.data?.phone_number
                    }
                    type="number"
                    handleChange={(val) => {
                      handleShipAddressInput(val, "delivery_contact_number");
                      setcontactNo(val);
                    }}
                    regex={Regex.phoneNumber.test(contactNo)}
                    errorMsg={localization.phoneError}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <ConstantInput
                    label={localization.email}
                    value={
                      siteByNo?.data?.poc?.email !== undefined
                        ? siteByNo?.data?.poc?.email
                        : storeAddress?.data?.email
                    }
                    type="text"
                    handleChange={(val) => {
                      handleShipAddressInput(val, "delivery_contact_email");
                      setEmail(val);
                    }}
                    regex={Regex.email.test(email)}
                    errorMsg={localization.emailError}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <ConstantInput
                    label={localization.pinCode}
                    value={
                      clientShippingAddress?.pincode !== undefined  ? clientShippingAddress?.pincode : 
                      siteByNo?.data?.siteShipAddress?.pincode !==
                      undefined
                        ? siteByNo?.data?.siteShipAddress?.pincode
                        : siteByNo?.data?.siteBillAddress?.pincode !==
                        undefined
                          ? siteByNo?.data?.siteBillAddress?.address_line_1
                          : storeAddress?.data?.geo_pincode?.pincode
                    }
                    type="text"
                    handleChange={(val) => {
                      handleShipAddressInput(val, "delivery_pincode");
                      handlePincode(val);
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <ConstantInput
                    label={localization.city}
                    value={
                      clientShippingAddress?.city !== undefined  ? clientShippingAddress?.city : 
                      siteByNo?.data?.siteShipAddress?.city !==
                      undefined
                        ? siteByNo?.data?.siteShipAddress?.city
                          : pincode?.city_name
                    }
                    
                    type="text"
                    handleChange={(val) =>
                      handleShipAddressInput(val, "delivery_city")
                    }
                    disabled={true}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <ConstantInput
                    label={localization.state}
                    value={
                      clientShippingAddress?.state !== undefined  ? clientShippingAddress?.state :
                      siteByNo?.data?.siteShipAddress?.state !==
                      undefined
                        ? siteByNo?.data?.siteShipAddress?.state
                          : pincode?.state_name
                    }
                    
                    type="text"
                    handleChange={(val) =>
                      handleShipAddressInput(val, "delivery_state")
                    }
                    disabled={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.address1}
                    value={
                      clientShippingAddress?.address_line_1 !== undefined  ? clientShippingAddress?.address_line_1 :
                      siteByNo?.data?.siteShipAddress?.address_line_1 !==
                      undefined
                        ? siteByNo?.data?.siteShipAddress?.address_line_1
                        : siteByNo?.data?.siteBillAddress?.address_line_1 !==
                        undefined
                          ? siteByNo?.data?.siteBillAddress?.address_line_1
                          : storeAddress?.data?.address_first
                    }
                    type="text"
                    handleChange={(val) =>
                      handleShipAddressInput(val, "delivery_address_first")
                    }
                  />
                  {/* <ConstantInput
                    label={localization.address1}
                    value={
                      siteByNo?.data?.siteBillAddress?.address_line_1 !==
                      undefined
                        ? siteByNo?.data?.siteBillAddress?.address_line_1
                        : storeAddress?.data?.address_first
                    }
                    type="text"
                    handleChange={(val) =>
                      handleShipAddressInput(val, "delivery_address_first")
                    }
                  /> */}
                </div>
                <div className="col-md-6 col-sm-12">
                  <ConstantInput
                    label={localization.address2}
                    value={
                      clientShippingAddress?.address_line_2 !== undefined  ? clientShippingAddress?.address_line_2 :
                      siteByNo?.data?.siteShipAddress?.address_line_2 !==
                      undefined
                        ? siteByNo?.data?.siteShipAddress?.address_line_2
                        :siteByNo?.data?.siteBillAddress?.address_line_2 !==
                        undefined
                          ? siteByNo?.data?.siteBillAddress?.address_line_2
                          : storeAddress?.data?.address_second

                      
                    }
                    type="text"
                    handleChange={(val) =>
                      handleShipAddressInput(val, "delivery_address_second")
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              {localization.MaterialRequirement}
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  {parseInt(materialTypeId) !== 12 ? (
                    <DropDownInput
                      label={localization.materialsServiceType}
                      data={[{ id: 1, name: "Mat Code" }]}
                      getIdValue={(val) => {
                        setMaterialServiceType(val.id);
                        handleInput(val.id, "material_service_type");
                      }}
                      value={""}
                      isStarRequired={true}
                    />
                  ) : parseInt(materialTypeId) === 12 ? (
                    <>
                      <DropDownInput
                        label={localization.materialsServiceType}
                        data={[{ id: 2, name: "Non Mat Code" }]}
                        getIdValue={(val) => {
                          setMaterialServiceType(val.id);
                          handleInput(val.id, "material_service_type");
                        }}
                        value={""}
                        isStarRequired={true}
                      />
                    </>
                  ) : (
                    <DropDownInput
                      label={localization.materialsServiceType}
                      data={[
                        { id: 1, name: "Mat Code" },
                        { id: 2, name: "Non Mat Code" },
                      ]}
                      getIdValue={(val) => {
                        setMaterialServiceType(val.id);
                        handleInput(val.id, "material_service_type");
                      }}
                      value={""}
                      isStarRequired={true}
                    />
                  )}
                </div>
                {materialServiceType === 1 && (
                  <>
                  <div className="col-md-12">
                    <DropDownInput
                      label={localization.category}
                      data={CategoryData}
                      getIdValue={(val) => {
                        // handleMaterialSelect(val.id);
                        setCategoryId(val.id);
                      }}
                      value={""}
                      isStarRequired={true}
                    />
                  </div>
                {BrandData && BrandData.length > 0 ?
                  <div className="col-md-12">
                  <DropDownInput
                    label={localization.brand}
                    data={BrandData}
                    getIdValue={(val) => {
                      // handleMaterialSelect(val.id);
                      setBrandId(val.id);
                    }}
                    value={""}
                    isStarRequired={true}
                  />
                </div>
                :<>
                  {categoryId && <div className="col-md-12" style={{color:'red'}}>Brand Not Found</div>}
                </>
                }
                {BrandData && BrandData.length > 0 && brandId && MaterialData && MaterialData.length > 0 ?
                  <div className="col-md-12">
                    <DropDownInput
                      label={localization.material}
                      data={MaterialData}
                      getIdValue={(val) => {
                        handleMaterialSelect(val.id);
                        handleInput(val.id, "material_id");
                      }}
                      value={""}
                      isStarRequired={true}
                    />
                  </div>
                  :<>
                  {BrandData && BrandData.length > 0 && brandId && <div className="col-md-12" style={{color:'red'}}>Material Not Found</div>}
                  </>
                }
                  </>
                )}
                {materialServiceType === 2 && (
                  <>
                    <div className="row" style={{ marginLeft: "0%" }}>
                      {nonCoatedServiceType.map((val, i) => {
                        return (
                          <>
                            <div className="col-md-6" id={i + 4}>
                              <ConstantInput
                                label={localization.name}
                                value={val.name}
                                type="text"
                                handleChange={(val) =>
                                  saveCoatedService(i, val, "name")
                                }
                              />
                            </div>
                            <div className="col-md-6" id={i + 1}>
                              <ConstantInput
                                label={localization.description}
                                value={val.description}
                                type="text"
                                handleChange={(val) =>
                                  saveCoatedService(i, val, "description")
                                }
                              />
                            </div>
                            <div className="col-md-6" id={i + 2}>
                              <ConstantInput
                                label={localization.quantity}
                                value={val.qty}
                                type="number"
                                handleChange={(val) =>
                                  saveCoatedService(i, val, "qty")
                                }
                                regex={Regex.numericNotZero.test(val.qty)}
                                errorMsg={localization.enterValidData}
                              />
                            </div>
                            {/*<div className="col-md-6" id={i + 3}>*/}
                            {/*    <ConstantInput*/}
                            {/*        label={localization.price}*/}
                            {/*        value={val.price}*/}
                            {/*        type="number"*/}
                            {/*        handleChange={(val) =>*/}
                            {/*            saveCoatedService(i, val, 'value')*/}
                            {/*        }*/}
                            {/*        disabled={true}*/}
                            {/*    />*/}
                            {/*</div>*/}
                            <div
                              className="btn-box mb-4"
                              style={{ width: "100%" }}
                            >
                              {nonCoatedServiceType.length !== 1 && (
                                <>
                                  <button
                                    onClick={() => handleCoatedServiceRemove(i)}
                                    className="btn btn-sm btn-danger mr10"
                                  >
                                    Remove
                                  </button>
                                </>
                              )}
                              {nonCoatedServiceType.length - 1 === i && (
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => handleCoatedServiceAdd()}
                                >
                                  Add
                                </button>
                              )}
                            </div>
                          </>
                        );
                      })}
                    </div>
                  </>
                )}
                {associateMaterialData &&
                  associateMaterialData.length > 1 &&
                  associateMaterialData !== [] && (
                    <div className="col-md-12" style={{ overflowX: "auto" }}>
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Brand</th>
                            <th>Name</th>
                            <th>Quantity</th>
                            <th>Sale Price (Per Qty)</th>
                            <th>Specification</th>
                            {/*{(parseInt(materialTypeId) === 13 || parseInt(materialTypeId) === 14
                                                    || parseInt(materialTypeId) === 15 || parseInt(materialTypeId) === 16 || parseInt(materialTypeId) === 17
                                                    || parseInt(materialTypeId) === 18 || parseInt(materialTypeId) === 19 || parseInt(materialTypeId) === 20
                                                    || parseInt(materialTypeId) === 21 || parseInt(materialTypeId) === 22) &&
                                                    <th>Inventory</th>
                                                }*/}
                            {(parseInt(materialTypeId) === 1 ||
                              parseInt(materialTypeId) === 2 ||
                              parseInt(materialTypeId) === 4 ||
                              parseInt(materialTypeId) === 11) && (
                              <th>Is Returnable</th>
                            )}
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {associateMaterialData.map((val, i) => {
                            return (
                              <>
                                {val?.material !== undefined && (
                                  <tr>
                                    <td>{val?.material?.brand_name}</td>
                                    <td>{val?.material?.name}</td>
                                    <td>
                                      <ConstantInput
                                        // label={localization.contactName}
                                        value={val?.material?.Quantity}
                                        type="text"
                                        handleChange={(value) =>
                                          handleMaterialPrice(
                                            "material",
                                            "Quantity",
                                            value,
                                            val?.material?.id
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <ConstantInput
                                        // label={localization.contactName}
                                        value={val?.material?.sale_value}
                                        type="text"
                                        handleChange={(value) =>
                                          handleMaterialPrice(
                                            "material",
                                            "sale_value",
                                            value,
                                            val?.material?.id
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <ConstantInput
                                        // label={localization.contactName}
                                        value={val?.material?.specification}
                                        type="text"
                                        handleChange={(value) =>
                                          handleMaterialPrice(
                                            "material",
                                            "specification",
                                            value,
                                            val?.material?.id
                                          )
                                        }
                                      />
                                    </td>
                                    {/*{(parseInt(materialTypeId) === 13 || parseInt(materialTypeId) === 14
                                                                    || parseInt(materialTypeId) === 15 || parseInt(materialTypeId) === 16 || parseInt(materialTypeId) === 17
                                                                    || parseInt(materialTypeId) === 18 || parseInt(materialTypeId) === 19 || parseInt(materialTypeId) === 20
                                                                    || parseInt(materialTypeId) === 21 || parseInt(materialTypeId) === 22) &&
                                                                    <td>
                                                                        <DropDownInput
                                                                            label={" "}
                                                                            data={val?.material?.InventoryData}
                                                                            getIdValue={(value) =>
                                                                                handleMaterialPrice('material', 'Inventory', value, val?.material?.id)
                                                                            }
                                                                            value={''}
                                                                            isStarRequired={true}
                                                                            multipule={true}
                                                                        />
                                                                    </td>
                                                                }*/}
                                    {(parseInt(materialTypeId) === 1 ||
                                      parseInt(materialTypeId) === 2 ||
                                      parseInt(materialTypeId) === 4 ||
                                      parseInt(materialTypeId) === 5 ||
                                      parseInt(materialTypeId) === 11) && (
                                      // <td>
                                      //     <div style={{marginTop: "26px"}}>
                                      //         <input
                                      //             type="checkbox"
                                      //             name={""}
                                      //             onChange={(e) =>
                                      //                 handleMaterialPrice('material', 'refundable', e.target.checked, val?.material?.id)
                                      //             }
                                      //             className="mr-2"
                                      //         />
                                      //     </div>
                                      // </td>
                                      <td>
                                        <div>
                                          <DropDownInput
                                            label={"Is Returnable"}
                                            data={[
                                              { id: 1, name: "Yes" },
                                              { id: 0, name: "No" },
                                            ]}
                                            getIdValue={(value) =>
                                              handleMaterialPrice(
                                                "material",
                                                "refundable",
                                                value.id,
                                                val?.material?.id
                                              )
                                            }
                                            // value={''}
                                            isStarRequired={true}
                                          />
                                        </div>
                                      </td>
                                    )}
                                    <td>
                                      <span className="accept-reject">
                                        <Link
                                          to={"#"}
                                          className="reject"
                                          onClick={() => {
                                            handleTrash(val?.material.id);
                                          }}
                                        ></Link>
                                      </span>
                                    </td>
                                  </tr>
                                )}

                                {val?.associated_material &&
                                  val?.associated_material !== undefined &&
                                  val?.associated_material.map(
                                    (value, index) => {
                                      return (
                                        <>
                                          <tr>
                                            <td>Associated Material</td>
                                            <td>{value[1]?.name}</td>
                                            <td>
                                              <ConstantInput
                                                // label={localization.contactName}
                                                value={
                                                  value[2]?.Quantity *
                                                  val?.material?.Quantity
                                                }
                                                type="text"
                                                handleChange={(val) =>
                                                  handleMaterialPrice(
                                                    "associated",
                                                    "Quantity",
                                                    val,
                                                    value[4]?.id
                                                  )
                                                }
                                                disabled={true}
                                              />
                                            </td>
                                            <td>
                                              <ConstantInput
                                                // label={localization.contactName}
                                                value={value[3]?.sale_value}
                                                type="text"
                                                handleChange={(val) =>
                                                  handleMaterialPrice(
                                                    "associated",
                                                    "sale_value",
                                                    val,
                                                    value[4]?.id
                                                  )
                                                }
                                                disabled={true}
                                              />
                                            </td>
                                          </tr>
                                        </>
                                      );
                                    }
                                  )}
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">{localization.others}</div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <ConstantInput
                    label={localization.poNo}
                    value={""}
                    type="text"
                    handleChange={(val) => handleInput(val, "po_number")}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <FileUpload
                    id={"addPoAttachment"}
                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                    documentUploadUrl={documentUploadUrlPublic}
                    documentUrlData={documentUrlDataPublic}
                    onChange={(val) => savePoImage(val)}
                    // prefilledFilename={val?.url ? 'Image uploaded' : ""}
                  >
                    <span className="btn btn-transparent">Attachment</span>
                  </FileUpload>
                </div>
                <div className="col-md-6 col-sm-12">
                  <DatePicker
                    handleChange={(val) => handleInput(val, "date")}
                    label={localization.planDeliveryDate}
                    required={false}
                    // minimumDate={minDate}
                    maxDate={maxDateState}
                    value={""}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <ConstantInput
                    label={localization.remarkForStore}
                    value={""}
                    type="text"
                    handleChange={(val) => handleInput(val, "remark")}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <ConstantInput
                    label={localization.remarkForApprover}
                    value={""}
                    type="text"
                    handleChange={(val) =>
                      handleInput(val, "remark_for_approver")
                    }
                    isStarRequired={true}
                  />
                </div>
                <div className="col-md-6">
                  <DropDownInput
                    label={localization.modeOfTransport}
                    data={[
                      { id: "Self", name: "Self" },
                      { id: "Courier", name: "Courier" },
                    ]}
                    getIdValue={(val) =>
                      handleInput(val.id, "mode_of_transport")
                    }
                    value={""}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-md-6">
                  <DropDownInput
                    label={localization.scope}
                    data={[
                      { id: 1, name: "Park+" },
                      { id: 2, name: "Client" },
                    ]}
                    getIdValue={(val) => handleInput(val.id, "scope_id")}
                    value={""}
                    isStarRequired={true}
                  />
                </div>
                {
                  inputList[0].scope_id === 1 && 
                    <>
                      <div className="col-md-6">
                        <DropDownInput
                          label={localization.is_billable}
                          data={[
                            { id: 'yes', name: "Yes" },
                            { id: 'no', name: "No" },
                          ]}
                          getIdValue={(val) => handleInput(val.id, "is_billable")}
                          value={""}
                          isStarRequired={true}
                        />
                      </div>
                      {
                        inputList[0].is_billable === 'yes' && 
                        <div className="col-md-6 col-sm-12">
                          <ConstantInput
                            label={localization.pi_no}
                            value={""}
                            type="text"
                            handleChange={(val) => handleInput(val, "pi_no")}
                            isStarRequired={true}
                          />
                        </div>
                      }
                    </>
                }
                <div className="col-md-6">
                  <DropDownInput
                    label={localization.flow}
                    data={[
                      { id: "Normal Flow", name: "Normal Flow" },
                      { id: "Credit Limit Flow", name: "Credit Limit Flow" },
                    ]}
                    getIdValue={(val) => handleInput(val.id, "mrf_flow")}
                    value={""}
                    isStarRequired={true}
                  />
                </div>

                { inputList[0].mrf_flow === "Normal Flow" && parseInt(materialTypeId) === 3 &&(
                    <div className="col-md-6">
                    <DropDownInput
                        label={localization.advancePick}
                        data={[
                        { id: "Yes", name: "Yes" },
                        { id: "No", name: "No" },
                        ]}
                        getIdValue={(val) => handleInput(val.id, "advance_pick")}
                        value={""}
                        isStarRequired={true}
                    />
                    </div>
                )}

              </div>

              {/* payment portal card starts */}
              { inputList[0].advance_pick === "Yes" && (
                <div className="card">
                  <div className="card-header">
                    {localization.paymentPortal}
                  </div>
                  <div className="card-body">
                    <div className="root">
                      {inputList.map((x, i) => {
                        return (
                          <div>
                            <div className="parallel_fields">
                              <DropDownInput
                                label={localization.paymentMode}
                                disabled={isView}
                                data={[
                                  { id: "Cash", name: "Cash" },
                                  { id: "Cheque", name: "Cheque" },
                                  { id: "NEFT", name: "NEFT" },
                                  { id: "IMPS", name: "IMPS" },
                                  { id: "RTGS", name: "RTGS" },
                                  { id: "UPI", name: "UPI" },
                                  { id: "NACH", name: "NACH" },
                                  { id: "PDC_CHEQUE", name: "PDC_CHEQUE" },
                                ]}
                                required
                                errorMsg={localization.paymentMode}
                                value={
                                  isEdit || isView ? rowData?.payment_mode : ""
                                }
                                getIdValue={(val) => {
                                  setPayData({
                                    ...payData,
                                    payment_mode: val.id,
                                  });
                                  handledropDownChange(val, i, "payment_mode");
                                  handledropDownChange(
                                    { id: null, value: "" },
                                    i,
                                    "status"
                                  );
                                }}
                                isStarRequired={true}
                              />
                              <ConstantInput
                                label={localization.transAmount}
                                type="number"
                                disabled={isView}
                                required
                                value={isEdit || isView ? rowData?.amount : ""}
                                handleChange={(val) => {
                                  setPayData({
                                    ...inputList,
                                    trans_amount: val,
                                  });
                                  handleConstInput(val, i, "trans_amount");
                                }}
                                isStarRequired={true}
                              />
                            </div>
                            <div className="parallel_fields">
                              <ConstantInput
                                label={localization.referenceNumber}
                                disabled={isView}
                                required
                                value={
                                  isEdit || isView
                                    ? rowData?.payment_reference
                                    : ""
                                }
                                handleChange={(val) => {
                                  setPayData({
                                    ...inputList,
                                    reference_number: val,
                                  });
                                  handleConstInput(val, i, "reference_number");
                                }}
                                isStarRequired={true}
                              />

                              <FormGroup
                                className={`date custom_date_picker ${
                                  isFocus1 ? "active-date" : ""
                                }`}
                              >
                                <label>
                                  {localization.transactionDate}
                                  <span
                                    className="label-star"
                                    style={{ color: "red" }}
                                  >
                                    {" "}
                                    *{" "}
                                  </span>
                                </label>
                                <DatePickerInput
                                  onChange={(e) =>
                                    handleDateChange(e, i, "adv_payment_date")
                                  }
                                  autoClose
                                  disabled={isView}
                                  defaultValue={
                                    isEdit || isView
                                      ? rowData?.transaction_date
                                      : ""
                                  }
                                  closeOnClickOutside
                                  showOnInputClick
                                  locale="en"
                                  className="my-custom-datepicker-component"
                                  required
                                  format="DD-MM-YYYY"
                                  displayFormat="DD-MM-YYYY"
                                  returnFormat="YYYY-MM-DD"
                                />
                                {!isFocus1 && (
                                  <label className="error date_error">
                                    {localization.transactionDate}
                                  </label>
                                )}
                              </FormGroup>
                            </div>
                            <div className="parallel_fields">
                              <DropDownInput
                                label={localization.status}
                                data={
                                  payment.payment_mode == "Cash" ||
                                  payment.payment_mode == "Cheque"
                                    ? [
                                        {
                                          id: "DEPOSITED IN BANK",
                                          name: "Deposited in Bank",
                                        },
                                        {
                                          id: "COLLECTED FROM CLIENT",
                                          name: "Collected from Client",
                                        },
                                        {
                                          id: "DEPOSITED TO FINANCE",
                                          name: "Deposited to Finance",
                                        },
                                      ]
                                    : [
                                        {
                                          id: "DEPOSITED IN BANK",
                                          name: "Deposited in Bank",
                                        },
                                        {
                                          id: "COLLECTED FROM CLIENT",
                                          name: "Collected from Client",
                                        },
                                        {
                                          id: "DEPOSITED TO FINANCE",
                                          name: "Deposited to Finance",
                                        },
                                        {
                                          id: "ONLINE TRANSACTION BY CLIENT",
                                          name: "Online Transaction by Client",
                                        },
                                      ]
                                }
                                required
                                value={isEdit || isView ? rowData?.status : ""}
                                controlledValue={inputList[0].status}
                                errorMsg={localization.paymentMode}
                                getIdValue={(val) => {
                                  setPayData({
                                    ...payData,
                                    status: val.id,
                                  });
                                  handledropDownChange(val, i, "status");
                                }}
                                disabled={x.payment_mode === "" || isView}
                                isStarRequired={true}
                              />
                              <DropDownInput
                                label="Select Bank"
                                disabled={isView}
                                data={[
                                  {
                                    id: "HDFC",
                                    name: "HDFC",
                                  },
                                  {
                                    id: "IDFC",
                                    name: "IDFC",
                                  },
                                  {
                                    id: "ICICI",
                                    name: "ICICI",
                                  },
                                  {
                                    id: "IDBI",
                                    name: "IDBI",
                                  },
                                  {
                                    id: "STANDARD_CHARTERED",
                                    name: "STANDARD_CHARTERED",
                                  },
                                ]}
                                required
                                value={isEdit || isView ? rowData?.bank : ""}
                                errorMsg={localization.paymentMode}
                                getIdValue={(val) => {
                                  setPayData({
                                    ...payData,
                                    bank: val.id,
                                  });
                                  handledropDownChange(val, i, "bank");
                                }}
                                isStarRequired={true}
                              />
                            </div>
                            <div className="parallel_fields">
                              <ConstantInput
                                label="Payment Remark"
                                value={rowData?.remarks || ""}
                                disabled={isView}
                                required={true}
                                handleChange={(val) => {
                                  setPayData({
                                    ...payData,
                                    payment_remark: val,
                                  });
                                  handleConstInput(val, i, "payment_remark");
                                }}
                                isStarRequired={true}
                              />
                            <FileUpload
                                id={"paymentAttachment" + i}
                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                documentUploadUrl={documentUploadUrlPublic}
                                documentUrlData={documentUrlDataPublic}
                                onChange={(val) =>
                                  handleConstInput(val, i, "payment_document")
                                }
                                required
                            >
                                <span className="btn btn-transparent">
                                  {localization.uploadPaymentPhotos}
                                  <span
                                    className="label-star"
                                    style={{ color: "red" }}
                                  >
                                    *
                                  </span>
                                </span>
                            </FileUpload>

                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
              {/* payment portal card ends */}

              {/*{inputList[0].scope_id === 2 &&*/}
              {/*    <>*/}
              {/*        <div className="col-md-6">*/}
              {/*            <DropDownInput*/}
              {/*              label={localization.tiGenerated}*/}
              {/*              data={[*/}
              {/*                  {id: "Yes", name: "Yes"},*/}
              {/*                  {id: "No", name: 'No'}*/}
              {/*              ]}*/}
              {/*              getIdValue={(val) =>*/}
              {/*                handleInput(val.id, 'ti_generated')*/}
              {/*              }*/}
              {/*              value={departmentId == 2 ? 'Yes' : ''}*/}
              {/*              isStarRequired={true}*/}
              {/*              disabled={departmentId == 2 ? true : false}*/}
              {/*            />*/}
              {/*        </div>*/}
              {/*        {inputList[0].ti_generated === "Yes" &&*/}
              {/*            <>*/}
              {/*                <div className="col-md-6">*/}
              {/*                    <DropDownInput*/}
              {/*                      label={localization.invoices}*/}
              {/*                      data={siteByNo?.invoices}*/}
              {/*                      getIdValue={(val) => {handleInput(val.id, 'invoice_no')*/}
              {/*                          if (val?.id) {*/}
              {/*                            setInvoiceNo(val.id);*/}
              {/*                            let res = findById(siteByNo?.invoices, val.id);*/}
              {/*                            handleInput(res, 'invoice_amount')*/}
              {/*                            setInvoiceAmt(res);*/}
              {/*                          }*/}
              {/*                        // console.log(res);*/}
              {/*                      }}*/}
              {/*                      value={''}*/}
              {/*                      isStarRequired={true}*/}
              {/*                    />*/}
              {/*                </div>*/}
              {/*                <div className="col-md-6">*/}
              {/*                    <ConstantInput*/}
              {/*                      label={localization.invoiceNo}*/}
              {/*                      value={invoiceNo}*/}
              {/*                      type="text"*/}
              {/*                      disabled*/}
              {/*                      // isStarRequired={true}*/}
              {/*                    />*/}
              {/*                </div>*/}

              {/*                <div className="col-md-6">*/}
              {/*                    <ConstantInput*/}
              {/*                      label={localization.invoiceAmount}*/}
              {/*                      value={invoiceAmt}*/}
              {/*                      type="text"*/}
              {/*                      disabled*/}
              {/*                      // isStarRequired={true}*/}
              {/*                    />*/}
              {/*                </div>*/}
              {/*                <div className="col-md-6">*/}
              {/*                    <DropDownInput*/}
              {/*                      label={localization.paymentReceived}*/}
              {/*                      data={[*/}
              {/*                          {id: 'Yes', name: "Yes"},*/}
              {/*                          {id: 'No', name: 'No'}*/}
              {/*                      ]}*/}
              {/*                      getIdValue={(val) =>*/}
              {/*                        handleInput(val.id, 'payment_received')*/}
              {/*                      }*/}
              {/*                      value={''}*/}
              {/*                      isStarRequired={true}*/}
              {/*                    />*/}
              {/*                </div>*/}
              {/*            </>*/}
              {/*        }*/}

              {/*        {inputList[0].payment_received === 'Yes' &&*/}
              {/*            <>*/}
              {/*                <div className="col-md-6">*/}
              {/*                    <ConstantInput*/}
              {/*                        label={localization.chequeUTRNo}*/}
              {/*                        value={""}*/}
              {/*                        type="text"*/}
              {/*                        handleChange={(val) =>*/}
              {/*                            handleInput(val, 'cheque_utr_no')*/}
              {/*                        }*/}
              {/*                        isStarRequired={true}*/}
              {/*                    />*/}
              {/*                </div>*/}
              {/*                <div className="col-md-6">*/}
              {/*                    <FileUpload*/}
              {/*                        id={"addAttachment" + 90}*/}
              {/*                        accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
              {/*                        documentUploadUrl={documentUploadUrlPublic}*/}
              {/*                        documentUrlData={documentUrlDataPublic}*/}
              {/*                        onChange={(val) =>*/}
              {/*                            handleInput(val, 'cheque_utr_photo')*/}
              {/*                        }*/}
              {/*                        prefilledFilename={""}*/}
              {/*                    >*/}
              {/*                        <span className="btn btn-transparent">*/}
              {/*                            {localization.chequeUTRPhoto}*/}
              {/*                        </span>*/}
              {/*                    </FileUpload>*/}
              {/*                </div>*/}
              {/*                <div className="col-md-6">*/}
              {/*                    <DatePicker*/}
              {/*                        handleChange={(val) =>*/}
              {/*                            handleInput(val, 'cheque_utr_date')*/}
              {/*                        }*/}
              {/*                        label={localization.chequeUTRDate}*/}
              {/*                        value={""}*/}
              {/*                    />*/}
              {/*                </div>*/}
              {/*            </>*/}
              {/*        }*/}
              {/*    </>*/}
              {/*}*/}

              <br />
              <br />

              <div className="container-fluid">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      {images.map((val, i) => {
                        return (
                          <>
                            {/*<div className="col-sm-12">*/}
                            <div className="col-md-5">
                              <FileUpload
                                id={"addAttachment" + i}
                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                documentUploadUrl={documentUploadUrlPublic}
                                documentUrlData={documentUrlDataPublic}
                                onChange={(val) => saveImages(i, val)}
                                prefilledFilename={
                                  val?.url ? "Image uploaded" : ""
                                }
                              >
                                <span className="btn btn-transparent">
                                  Attachment
                                </span>
                              </FileUpload>
                            </div>
                            {images.length !== 1 && (
                              <div className="col-sm-3 mb-4">
                                <button
                                  onClick={() => handleRemove(i)}
                                  className="btn btn-sm btn-danger mr10"
                                >
                                  Remove
                                </button>
                              </div>
                            )}
                            {images.length - 1 === i && (
                              <div className="col-sm-2">
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => handleAddImages()}
                                >
                                  Add More
                                </button>
                              </div>
                            )}
                          </>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 mb-2">
            <center>
              <Button onClick={handleConfirmation} disabled={submitDisable}>
                {localization.submitDtl}
              </Button>
            </center>
          </div>
        </div>
        <ModalPop
            title={localization.conf}
            show={isModal}
            // handleModalHide={handleModalHide}
            keyboard
            backdrop
          >
          <div className="text-left ml-5">
            <h4>The MRF/Invoice will be generated towards this Client Address:</h4><br/>
            <div className="row" >
              <div className="col-md-6 infoModal">
                <span>Address Line 1</span> <p>
                {clientBillingAddress?.address_line_1 !== undefined ? clientBillingAddress?.address_line_1 : siteByNo?.data?.siteBillAddress?.address_line_1 !== undefined ? storeAddress?.data?.address_first : ''}
                </p>
              </div>
              <div className="col-md-6 infoModal">
                <span>Address Line 2</span> <p>
                {clientBillingAddress?.address_line_2 !== undefined ? clientBillingAddress?.address_line_2 : siteByNo?.data?.siteBillAddress?.address_line_2 !== undefined ? storeAddress?.data?.address_second : ''}
                </p>
              </div>
            </div>
            <div className="row" >
              <div className="col-md-6 infoModal">
                <span>City</span> <p>
                  {clientBillingAddress?.city !== undefined ? clientBillingAddress?.city : siteByNo?.data?.siteBillAddress?.city !== undefined ? storeAddress?.data?.geo_city?.city_name : ''}
                </p>
              </div>
              <div className="col-md-6 infoModal">
                <span>State</span> <p>
                  {clientBillingAddress?.state !== undefined ? clientBillingAddress?.state : siteByNo?.data?.siteBillAddress?.state !== undefined ? storeAddress?.data?.geo_state?.state_name :''}
                </p>
              </div>
            </div>
            <div className="row" >
              <div className="col-md-6 infoModal">
                <span>PIN Code</span> <p>{clientBillingAddress?.pincode !== undefined  ? clientBillingAddress?.pincode : siteByNo?.data?.siteBillAddress?.pincode !== undefined ? storeAddress?.data?.geo_pincode?.pincode : ''}</p>
              </div>
              <div className="col-md-6 infoModal">
                <span>Client GST</span> <p>
                {clientBillingAddress?.client_gst !== undefined  ? clientBillingAddress?.client_gst :
                        siteByNo?.data?.lead_commercial?.gst_no ?  siteByNo?.data?.lead_commercial?.gst_no : ''}
                </p>
              </div>

            </div>
            <p class="note">
              Please note that if this is incorrect, you will need to raise a Credit Note. No tech support will be provided for the same.
            </p>

            <p>
                If you need to invoice a different Client Address for this MRF, please select that address / ask the Finance team to map the correct Client Address to this Contract before raising this MRF.
            </p>
            <div className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6">
            <div className="actions">
              <Button onClick={handleModalClose} className="btn btn-danger btn-sm">
                {`No Modify`}
              </Button>
              <Button onClick={handleOnSubmitForm} disabled={submitDisable} className="btn-sm">
                {`Yes Submit MRF`}
              </Button>
            </div>
            </div>
            </div>
              
          </div>
        </ModalPop>
      </Layout>
    </>
  );
};

export default CreateMrf;
